import { TutorialTemplate } from "@components/templates";
import React from "react";

import tutorial1Icon from "@assets/images/icon_tutorial_1.png";
import { Row } from "@components/atoms";
import { Colors } from "@utils";
import styled from "styled-components";
import { GradeBGColor, GradeTrophyIcon } from "@utils/Constants";

import tutorial1Image from "@assets/images/tutorial_1_image.png";

const Bar = styled.div`
  width: 1px;
  height: 13px;
  background: ${Colors.primaryGreen};
  position: absolute;
  left: 62px;
  top: 88px;
`;

const ContentArea = styled.div`
  border-radius: 10px;
  border: 1px solid ${Colors.primaryGreen};
  background: ${Colors.white};
  padding: 0px 19px;
  margin-left: 38px;
  margin-right: 44px;
  margin-top: 13px;
  height: 147px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ContentAreaShadow = styled.div`
  position: absolute;
  left: 42px;
  right: 40px;
  top: 110px;
  border-radius: 10px;
  border: 1px solid ${Colors.primaryGreen};
  height: 147px;
`;

const Trophy = styled.img`
  width: 49px;
  height: 48px;
`;

const Chip = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  color: ${Colors.white};
  width: 40px;
  height: 17px;
  border-radius: 10px;
`;

const GRADES = Object.keys(GradeTrophyIcon) as HealthGrade[];

const Tutorial1Page = () => {
  return (
    <TutorialTemplate page={1}>
      <div className="flex grow flex-col pt-[38px] pb-[32px] relative">
        <Row className="pl-[38px]">
          <img
            src={tutorial1Icon}
            alt=""
            className="w-[50px] h-[50px] mr-[12px]"
          />
          <div>
            <div
              className="text-[14px] font-[700]"
              style={{ color: Colors.totallyBlack }}
            >
              ⁠종합 건강성적 분석
            </div>
            <div
              className="text-[11px] font-[400]"
              style={{ color: Colors.totallyBlack }}
            >
              ⁠동성동년 대비 건강 성적, 건강 나이, 기대수명
            </div>
          </div>
        </Row>
        <Bar />
        <ContentAreaShadow />
        <ContentArea>
          <div
            className="text-[16px] font-[400] ml-[4px] mb-[15px]"
            style={{ color: Colors.totallyBlack }}
          >
            건강 등급:
          </div>
          <Row style={{ gap: "10%", justifyContent: "center" }}>
            {GRADES.map((grade) => (
              <div key={grade} className="flex flex-col items-center">
                <Trophy src={GradeTrophyIcon[grade]} />
                <Chip
                  className="mt-[11px]"
                  style={{
                    background: GradeBGColor[grade],
                  }}
                >
                  {grade}
                </Chip>
              </div>
            ))}
          </Row>
        </ContentArea>
        <div className="grow mt-[43px]" />
        <img
          style={{
            maxHeight: "208px",
            objectFit: "contain",
          }}
          alt=""
          src={tutorial1Image}
        />
      </div>
    </TutorialTemplate>
  );
};

export default Tutorial1Page;
